import { persistReducer, persistStore } from "redux-persist";
import storage from 'redux-persist/lib/storage';
import  qps  from "./Qps";
import { configureStore } from "@reduxjs/toolkit";

const persistConfig = {
    key : 'root',
    storage
    
}
const persistedReducer = persistReducer(persistConfig,qps)

const store = configureStore ({
    reducer :{
        qps: persistedReducer,
    },
});

const persistor = persistStore(store);

export {store,persistor};